var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 50 50 50 50 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "remark/3.1.1-\\u623F\\u8CB8\\u7522\\u54C1-\\u5167\\u9801",
    transform: "translate(-220.000000, -708.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group-2",
    transform: "translate(220.000000, 566.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.15625,25.78125 L35.15625,24.21875 C35.15625,17.34375 29.53125,11.71875 22.65625,11.71875 L17.1875,11.71875 C10.3125,11.71875 4.6875,17.34375 4.6875,24.21875 L4.6875,41.40625 C2.5390625,41.40625 0.78125,43.1640625 0.78125,45.3125 C0.78125,47.4609375 2.5390625,49.21875 4.6875,49.21875 L25,49.21875",
    id: "Stroke-1",
    stroke: "#A17D58",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4375,11.71875 L16.40625,11.71875 C15.546875,11.71875 14.84375,11.015625 14.84375,10.15625 C14.84375,9.296875 15.546875,8.59375 16.40625,8.59375 L23.4375,8.59375 C24.296875,8.59375 25,9.296875 25,10.15625 C25,11.015625 24.296875,11.71875 23.4375,11.71875 Z",
    id: "Stroke-3",
    stroke: "#A17D58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.65625,8.59375 L17.1875,8.59375 C15.0390625,8.59375 13.28125,6.8359375 13.28125,4.6875 C13.28125,2.5390625 15.0390625,0.78125 17.1875,0.78125 C20.3125,3.125 22.65625,0.78125 22.65625,0.78125 C24.8046875,0.78125 26.5625,2.5390625 26.5625,4.6875 C26.5625,6.8359375 24.8046875,8.59375 22.65625,8.59375 Z",
    id: "Stroke-5",
    stroke: "#A17D58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.625,35.15625 C16.796875,37.5 19.140625,37.5 19.140625,37.5 L21.484375,37.5 C23.4179688,37.5 25,35.9179688 25,33.984375 C25,32.0507812 23.4179688,30.46875 21.484375,30.46875 L19.140625,30.46875 C17.2070312,30.46875 15.625,28.8867188 15.625,26.953125 C15.625,25.0195312 17.2070312,23.4375 19.140625,23.4375 L21.484375,23.4375 C21.484375,23.4375 23.828125,23.4375 25,25.78125",
    id: "Stroke-7",
    stroke: "#A17D58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3125,21.09375 L20.3125,23.4375",
    id: "Stroke-9",
    stroke: "#A17D58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3125,37.5 L20.3125,39.84375",
    id: "Stroke-11",
    stroke: "#A17D58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-13",
    stroke: "#A17D58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)",
    points: "29.6875 49.21875 44.53125 49.21875 44.53125 44.53125 29.6875 44.53125"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-15",
    stroke: "#A17D58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)",
    points: "31.25 44.53125 46.09375 44.53125 46.09375 39.84375 31.25 39.84375"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-16",
    stroke: "#A17D58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)",
    points: "34.375 39.84375 49.21875 39.84375 49.21875 35.15625 34.375 35.15625"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-17",
    stroke: "#A17D58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)",
    points: "32.8125 35.15625 47.6609851 35.15625 47.6609851 30.46875 32.8125 30.46875"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon3);
export default __webpack_public_path__ + "static/media/product-icon3.2b18fe30c491381e73596ff4a70d46f3.svg";
export { ForwardRef as ReactComponent };